import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { profileSelectors } from '../../../store/selectors/profile';

import SettingSwitcher from './SettingSwitcher/SettingSwitcher';
import ErrorMessage from '../../../common/Errors/ErrorMessage';
import SettingsSelect from './SettingsSelect/SettingsSelect';
import TimezoneSelect from './TimezoneSelect/TimezoneSelect';

import { messages } from './constants';

import './card-settings.style.scss';

/** Селекти займають увесь рядок: на 360px підпис і контрол в один рядок не влазять. */
const isSelectLike = (el) => el === 'select' || el === 'timezone';

const CardSettings = ({ title, el, hint }) => {
  const profile = useSelector(profileSelectors);
  const errors = profile.errors;

  const [active, setActive] = useState('');

  return (
    <>
      <div className='card-settings'>
        <div className={`card-settings__content ${isSelectLike(el) ? 'card-settings__content--col' : ''}`}>
          <h4 className="card-settings__title">{title}</h4>
          {el === 'switcher' &&  <SettingSwitcher active={active} setActive={setActive} />}

          {el === 'select' && <div className="card-settings__select">
            <SettingsSelect />
          </div>}

          {el === 'timezone' && <div className="card-settings__select">
            <TimezoneSelect />
          </div>}
        </div>

        {hint ? <div className='card-settings__message card-settings__message--hint'>{hint}</div> : null}

        {active === 'off' && el === 'switcher' 
        ? <div className='card-settings__message'>{messages[active]}</div> : ''}
        {errors?.value &&  errors.value.map(err => <ErrorMessage key={err} errorText={err} />)}
      </div>
    </>

  );
};

CardSettings.propTypes = {
  title: PropTypes.string.isRequired,
  el: PropTypes.string.isRequired,
  hint: PropTypes.string
};

CardSettings.defaultProps = {
  hint: ''
};

export default CardSettings;